import React from 'react';
import { Provider } from 'react-redux';
import AppRoute from './routes/index';
import configureStore from './redux/configureStore';
import AuthProvider from './providers/AuthProvider';

const store = configureStore();

const App = () => {
  return (
    <Provider store={store}>
      <AuthProvider>
        <AppRoute />
      </AuthProvider>
    </Provider>
  );
};

export default App;
